import red from '@material-ui/core/colors/red';
import pink from '@material-ui/core/colors/pink';
import purple from '@material-ui/core/colors/purple';
import deepPurple from '@material-ui/core/colors/deepPurple';
import indigo from '@material-ui/core/colors/indigo';
import blue from '@material-ui/core/colors/blue';
import lightBlue from '@material-ui/core/colors/lightBlue';
import cyan from '@material-ui/core/colors/cyan';
import teal from '@material-ui/core/colors/teal';
import green from '@material-ui/core/colors/green';
import lightGreen from '@material-ui/core/colors/lightGreen';
import lime from '@material-ui/core/colors/lime';
import yellow from '@material-ui/core/colors/yellow';
import amber from '@material-ui/core/colors/amber';
import orange from '@material-ui/core/colors/orange';
import deepOrange from '@material-ui/core/colors/deepOrange';
import brown from '@material-ui/core/colors/brown';
import grey from '@material-ui/core/colors/grey';
import blueGrey from '@material-ui/core/colors/blueGrey';

export function* getColor() {
  const OFFSET = 4;
  const SEQ = [ 500, 900, 100 ];
  let scount = 0;
  let i = 0;
  let count = 0;
  let countMax = cores.length;
  while (true) {
    // yield { cor:cores[i][1], seq:SEQ[scount], i, count, scount};
    yield cores[i][1][SEQ[scount]];
    if (i + OFFSET >= countMax) {
      if (count + 1 >= OFFSET) {
        count = 0;
        scount = (scount + 1 >= SEQ.length) ? 0 : (scount + 1)
      } else {
        count = count + 1
      }
      i = count;
    } else {
      i = i + OFFSET;
    }
  }
}

const cores = [
  ["red", red],
  ["pink", pink],
  ["purple", purple],
  ["deepPurple", deepPurple],
  ["indigo", indigo],
  ["blue", blue],
  ["lightBlue", lightBlue],
  ["cyan", cyan],
  ["teal", teal],
  ["green", green],
  ["lightGreen", lightGreen],
  ["lime", lime],
  ["yellow", yellow],
  ["amber", amber],
  ["orange", orange],
  ["deepOrange", deepOrange],
  ["brown", brown],
  ["grey", grey],
  ["blueGrey", blueGrey],
]


export function toRgb(color) {
  let r = parseInt(color.substring(1,3), 16);
  let g = parseInt(color.substring(3,5), 16);
  let b = parseInt(color.substring(5,7), 16);
  return [ r, g, b ]
}

export default cores;
